import React from "react";
import { useParams } from "react-router-dom";
import SectionArticlesUI from "./SectionArticlesUI";
import useManifest from "../../hooks/useManifest";

export const SectionArticles = () => {
  const { section } = useParams();

  const { articles, loading, error } = useManifest(section);

  return (
    <SectionArticlesUI
      section={section}
      articles={articles}
      error={error}
      loading={loading}
    />
  );
};
